import {
  translateSingleString as remoteTranslateSingleString,
  translationDetails,
  trnsFormat,
} from '@paywithextend/localization'
import React from 'react'

export type TranslateFn = {
  (source: string, expressions?: Record<string, string>): string
  (
    source: string,
    expressions: Record<string, string | React.ReactElement>,
  ): React.ReactElement
}

export function createTranslate(
  localeTranslations: Record<string, translationDetails>,
  defaultTranslations: Record<string, translationDetails>,
): TranslateFn {
  const translateString = remoteTranslateSingleString(
    localeTranslations,
    defaultTranslations,
  )
  const translateRich = trnsFormat(localeTranslations, defaultTranslations)

  function translate(
    source: string,
    expressions?: Record<string, string | React.ReactElement>,
  ): string | React.ReactElement {
    if (
      !expressions ||
      Object.values(expressions).every((v) => typeof v === 'string')
    ) {
      return translateString(
        source,
        expressions as Record<string, string> | undefined,
      )
    }
    return React.createElement(
      React.Fragment,
      null,
      ...translateRich(source, expressions),
    )
  }

  return translate as TranslateFn
}
